var $ = require('jquery');

$(function () {

	window.isGmapLoaded = false;
	var map, infowindow, clusterIcon, markerIcon, isMapLink = {}, isClusteringView, controlPosition, locations = [];

	function resetMap() {
		infowindow.close();
	}

	function initMap() {
		map = new google.maps.Map(document.getElementById('map'), {
			scaleControl: true,
			streetViewControl: false,
			mapTypeControl: false, // To disable satellite/terrain view controls.
			fullscreenControl: true,
			fullscreenControlOptions: {
				position: google.maps.ControlPosition[controlPosition]
			},
			zoomControl: true,
			zoomControlOptions: {
				position: google.maps.ControlPosition[controlPosition]
			},
		});

		infowindow = new google.maps.InfoWindow();

		var latlngbounds = new google.maps.LatLngBounds();

		var markers = locations.map(function (location, i) {

			var directionCoordinates = (parseFloat(location.Latitude) + ',' + parseFloat(location.Longitude)).toString();
			var directionUrl = 'https://www.google.com/maps/dir/?api=1&destination=' + directionCoordinates + '&zoom=8';
			var formatPostalCode = ((location.AddressFormat == "PostalCodeAfterCity") ? (location.City + ' ' + location.PostalCode) : (location.PostalCode + ' ' + location.City));
			var isGetDirectionLink = (isMapLink.ShowMapLink) ? '<a style="cursor:pointer;" onClick="window.open(\'' + directionUrl + '\',\'location=yes\');return false;">' + isMapLink.MapLinkText + '</a>' : "";

			var MarkerContent = '<div style="width:300px; font-size:16px; line-height: 25px; padding: 15px 10px 0;"><b style="display: block; margin-bottom: 13px;">' + location.FirmName + ((location.SecondaryName !== "") ? ' - ' + location.SecondaryName : "") + '</b>' + location.Address1 + '<br />' + location.Address2 + '<br />' + formatPostalCode + '<br />' + location.State + ' ' + location.Country + '<br />' + location.PhoneNumber + '<br />' + location.FaxNumber + '<br /><a onClick="window.open(\'' + location.LinkHref + '\',\'_blank\')"  _target="' + location.LinkTarget + '" style="margin-top:10px; cursor:pointer;">' + location.LinkText + '</a><br />' + isGetDirectionLink + '</div>';

			var locationMarker = new google.maps.Marker({
				position: { lat: parseFloat(location.Latitude), lng: parseFloat(location.Longitude) },
				map: map,
				icon: markerIcon,
				width: 50,
				height: 50,
			});

			locationMarker.addListener('mouseover', function () {
				var that = this;
				this.setAnimation(google.maps.Animation.BOUNCE);
				window.setTimeout(function () { that.setAnimation(null); }, 10);
			});

			locationMarker.addListener('click', function () {
				infowindow.setContent(MarkerContent);
				infowindow.open(map, locationMarker);
			});

			latlngbounds.extend(locationMarker.position);
			return locationMarker;
		});

		var clusterStyles = [
			{
				textColor: 'black',
				url: clusterIcon,
				height: 32,
				width: 32,
				anchorText: [1, 0],
				textSize: 13,
			}
		];

		var mcOptions = {
			gridSize: 50,
			styles: clusterStyles,
			maxZoom: 15
		};

		// To enable Marker Clusters view.
		if (isClusteringView) {
			new MarkerClusterer(map, markers, mcOptions);
		}

		//Get the boundaries of the Map.
		var bounds = new google.maps.LatLngBounds();

		//Center map and adjust Zoom based on the position of all markers.
		map.setCenter(latlngbounds.getCenter());
		map.fitBounds(latlngbounds);

		// Reset Map based on bounds.
		var controlUI = document.createElement('button');
		controlUI.className = "resetMapButton";
		controlUI.innerHTML = '<i class="material-icons" style="font-size: 28px;">refresh</i>';

		controlUI.addEventListener('click', function () {
			resetMap();
			map.setCenter(latlngbounds.getCenter());
			map.fitBounds(latlngbounds);
		});

		map.controls[google.maps.ControlPosition[controlPosition]].push(controlUI);
	}


	$(window).on('scroll', function () {
		var elem = document.getElementById("map");
		if (elem) {
			if (elem.getBoundingClientRect().top <= window.pageYOffset && !window.isGmapLoaded) {
				window.isGmapLoaded = true;
				initializationMapAPI();
			}
		}
	});


	function initializationMapAPI() {
		
		var placeholderId = $('#map').attr('data-map-id').toLowerCase().toString();
		var language = $('#map').attr('data-language').toLowerCase().toString();
		var contextId = $('#map').attr('data-map-context').toLowerCase().toString();

		$.ajax({
			type: 'GET',
			url: '/api/sitecore/mapmodule/getmapdata',
			data: {
				id: placeholderId,
				lang: language,
				context: contextId
			},
			success: function (data) {
				clusterIcon = data.ClusteringIcon;
				markerIcon = data.LocationIcon;
				isMapLink = {
					ShowMapLink: data.ShowMapLink,
					MapLinkText: data.MapLinkText
				};
				controlPosition = data.ControlPosition.toUpperCase();
				isClusteringView = data.UseClustering;

				locations = data.Locations;

				$.when(
					$.getScript("https://unpkg.com/@google/markerclustererplus@4.0.1/dist/markerclustererplus.min.js"),
					$.getScript("https://maps.googleapis.com/maps/api/js?key=" + data.ApiKey),
					$.Deferred(function (deferred) {
						$(deferred.resolve);
					})
				).done(function () {
					initMap();
				});
			},
			error: function () {
			},
			complete: function () {
			}
		});
	}

});
